import { all, fork } from 'redux-saga/effects';
import boostInitializationSaga from './boostInitializationSaga';
import boostActionSaga from './boostSaga';

export default function* boostSagas() {
  yield all([fork(boostInitializationSaga), fork(boostActionSaga)]);
}
